import LanguageSwitcher from "../LanguageSwitcher";

function DashboardPageHeader({ title, children }) {
  return (
    <header className="dashboard-header">
      <h1 className="dashboard-header__title">{title}</h1>
      <div className="dashboard-header__actions">
        {children}
        <LanguageSwitcher className="dashboard-lang-switcher" />
      </div>
    </header>
  );
}

export default DashboardPageHeader;
